import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EcitationSearchService } from 'src/services/ecitation-search.service';
import { EcitationUserService } from 'src/services/ecitation-user.service';
import { AlertService } from '../alert-notify/alert-notify.service';
import { AuthService } from 'src/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-ecitation-search',
    templateUrl: './ecitation-search.component.html',
    styleUrls: ['./ecitation-search.component.css'],
    standalone: false
})
export class EcitationSearchComponent implements OnInit, OnDestroy {
  listOfData: any;
  username: any;
  showReportResults: boolean = false;
  activeTab = 1;
  searchForm: any = FormGroup;
  labelMap: { [Key: string]: string } = {
    citationNumber: 'Citation number',
    issuedBy: 'Issued By',
    transmissionEndDate: 'Transmission End Date',
    transmissionStartDate: 'Transmission Start Date',
    courtEndDate: 'Court End Date',
    courtStartDate: 'Court Start Date',
    violationStartDate: 'Violation Start Date',
    violationEndDate: 'Violation End Date',
    servedStartDate: 'Served Start Date',
    servedEndDate: 'Served End Date',
    destination: 'Destination',
    status: 'Status',
    sortBy: 'Sort By'
  };
  sortName = 'citationNumber';
  sortDir = 'desc';
  outPut: any = [];
  agenciesList: any = [];
  today = '';
  selectedValue: any;
  showDetails: boolean = false;
  selectedItems: any = [];
  details: any = { Q: 'Queued', F: 'Failed', R: 'Rejected', D: 'Delivered' };
  alert: any;
  private subscription = new Subscription();
  userTypeView: any;

  // XML view feature
  xmlContent: string = '';
  selectedCitation: string = '';

  constructor(
    private route: Router,
    private ecitationSearchService: EcitationSearchService,
    private _formBuilder: FormBuilder,
    private ecitationUserService: EcitationUserService,
    private alertService: AlertService,
    public authType: AuthService,
    private modalService: NgbModal
  ) {
    this.subscription.add(this.ecitationUserService.reloadComponent1$.subscribe(() => {
      this.showReportResults = false;
      this.activeTab = 1;
      this.currentPage = 1;
      if (this.showDetails) {
        this.showDetails = false;
      }
      this.searchForm.reset(this.buidForm().value);
    }));
    this.subscription.add(this.ecitationUserService.reloadComponent1$.subscribe(() => {
      this.showReportResults = false;
      this.getAllAgencies();
    }));
  }

  ngOnInit() {
    this.userTypeView = this.authType.getUserType();
    this.searchForm = this.buidForm();
    this.getAllAgencies();
    this.authType.menuType = sessionStorage.getItem('menuType');
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    this.today = `${year}-${month}-${day}`;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  buidForm() {
    return this._formBuilder.group({
      citationNumber: [''],
      issuedBy: ['ALL', [Validators.required]],
      transmissionEndDate: [''],
      transmissionStartDate: [''],
      courtEndDate: ['',],
      courtStartDate: ['',],
      violationStartDate: ['',],
      violationEndDate: ['',],
      servedStartDate: ['',],
      servedEndDate: ['',],
      destination: [['ALL'], [Validators.required]],
      status: [['ALL'], [Validators.required]],
      sortBy: ['Citation Number']
    });
  }

  resetForm() {
    this.searchForm.reset(this.buidForm().value);
  }

  pageSize: number = 25;
  currentPage: number = 1;

  getItems() {
    const satrtIndex = (this.currentPage - 1) * this.pageSize;
    return this.outPut.content;
  }

  onPageChange(pageNumber: number) {
    this.currentPage = pageNumber;
    this.onSearch(this.sortName, this.sortDir);
  }

  getTotalPages(): number {
    return this.outPut.totalPages;
  }

  getVisiblePages(): number[] {
    const totalVisiblePages = 10;
    const visiblePages: number[] = [];
    const startPage = Math.max(1, this.currentPage - Math.floor(totalVisiblePages / 2));
    const endPage = Math.min(this.getTotalPages(), startPage + totalVisiblePages - 1);
    for (let i = startPage; i <= endPage; i++) {
      visiblePages.push(i);
    }
    return visiblePages;
  }

  onSort(event: any, name: any, isSortable: boolean) {
    if (isSortable) {
      let spanEle =
        event.target.querySelector('i') != null ? event.target.querySelector('i') : event.target,
        classList = spanEle.classList;
      let sortDir = 1;
      if (classList.contains('fa-sort') || classList.contains('fa-sort-up')) {
        classList.remove('fa-sort');
        classList.remove('fa-sort-up');
        classList.add('fa-sort-down');
        sortDir = -1;
      } else {
        classList.add('fa-sort-up');
        classList.remove('fa-sort-down');
      }
      this.sortBy(name, sortDir);
    }
  }

  sortBy(name: string, order: number) {
    var orderVal = order == 1 ? 'asc' : 'desc';
    this.sortName = name;
    this.sortDir = orderVal;
    this.onSearch(name, orderVal);
  }

  searchQuery() {
    return `You searched for: ${this.constructSearchString(this.searchForm)}`;
  }

  getCurrentPageTotal() {
    if (this.currentPage * this.pageSize > this.outPut.totalElements) {
      return this.outPut.totalElements;
    } else {
      return this.currentPage * this.pageSize;
    }
  }

  constructSearchString(formGroup: FormGroup): string {
    let searchParts: any = [];
    Object.keys(formGroup.controls).forEach(key => {
      const control: AbstractControl = formGroup.controls[key];
      const label = this.labelMap[key] || key;

      if (control.value !== null && control.value !== '') {
        searchParts.push(`${label}: ${control.value}`);
      }
    });
    return searchParts.join(', ');
  }

  onSearch(name = 'citationNumber', dec = 'desc') {
    const params = this.searchForm.value;
    console.log(params);
    if (this.searchForm.valid) {
      console.log(params.transmissionStartDate);
      const prePrams = {
        status: params.status,
        frontendDestinations: params.destination,
        agencyName: params.issuedBy,
        citationNumber: params.citationNumber,
        transmissionStartDate: params.transmissionStartDate,
        transmissionEndDate: params.transmissionEndDate,
        violationStartDate: params.violationStartDate,
        violationEndDate: params.violationEndDate,
        servedStartDate: params.servedStartDate,
        servedEndDate: params.servedEndDate,
        courtStartDate: params.courtStartDate,
        courtEndDate: params.courtEndDate,
        page: this.currentPage - 1,
        size: this.pageSize,
        sort: `${name},${dec}`
      };
      const postParam = this.generateParams(prePrams);
      this.ecitationSearchService.getSearchResults(postParam).subscribe((res) => {
        this.outPut = res;
        this.outPut.content.forEach((element: any, i: any) => {
          element.id = `search-${this.currentPage}-${i}`;
          element.checked = false;
        });
        this.showReportResults = true;
      });
    } else {
      alert('Please Fill all required Fields');
    }
  }

  /**
   * Opens modal with formatted XML content for the citation
   */
  viewXml(item: any, xmlModal: any): void {
    this.selectedCitation = item.citationNumber;
    this.ecitationSearchService.getCitationXml(item.citationNumber).subscribe(
      (xml: string) => {
        // Used XSLT-based formatter for indentation
        this.xmlContent = this.formatXmlWithXslt(xml);
        this.modalService.open(xmlModal, { size: 'lg' });
      },
      () => {
        this.alertService.error(`Unable to load XML for citation ${item.citationNumber}.`);
      }
    );
  }

  // new flags for copy status
  copySuccess = false;
  copyError   = false;

  copyXmlContent() {
    // reset both states
    this.copySuccess = this.copyError = false;

    navigator.clipboard.writeText(this.xmlContent)
      .then(() => {
        this.copySuccess = true;
        // clear the green state after 2s
        setTimeout(() => this.copySuccess = false, 2000);
      })
      .catch(() => {
        this.copyError = true;
        // clear the red state after 2s
        setTimeout(() => this.copyError = false, 2000);
      });
  }


  /**
   * Pretty-print XML string for display using browser XSLTProcessor
   */
  private formatXmlWithXslt(xml: string): string {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xml, 'application/xml');
    const xsltString = `<?xml version="1.0"?>
      <xsl:stylesheet version="1.0" xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
        <xsl:output method="xml" indent="yes"/>
        <xsl:template match="@*|node()">
          <xsl:copy>
            <xsl:apply-templates select="@*|node()"/>
          </xsl:copy>
        </xsl:template>
      </xsl:stylesheet>`;
    const xsltDoc = parser.parseFromString(xsltString, 'application/xml');
    const processor = new XSLTProcessor();
    processor.importStylesheet(xsltDoc);
    const resultDoc = processor.transformToDocument(xmlDoc);
    const serializer = new XMLSerializer();
    return serializer.serializeToString(resultDoc);
  }

  isSelected(item: any) {
    return this.selectedItems.some((r: any) => r.id === item.id);
  }

  toggleSelection(item: any) {
    const index = this.selectedItems.findIndex((selectedRow: any) => selectedRow.id === item.id);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
    } else {
      this.selectedItems.push(item);
    }
  }

  generateParams(params: any) {
    const queryParams = [];
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        if (params[key] !== '') {
          if (Array.isArray(params[key])) {
            params[key].forEach((value: string | number | boolean) => {
              let encodeKey = encodeURIComponent(key);
              let encodedvalue = encodeURIComponent(value);
              queryParams.push(encodeKey + '=' + encodedvalue);
            });
          } else {
            let encodeKey = encodeURIComponent(key);
            let encodedvalue = encodeURIComponent(params[key]);
            queryParams.push(encodeKey + '=' + encodedvalue);
          }
        }
      }
    }
    return queryParams.join('&');
  }

  getAllAgencies() {
    this.ecitationSearchService.getAllAgencies().subscribe((data) => {
      this.agenciesList = data;
    });
  }

  showDetaislStatus(data: any) {
    const prePrams = {
      status: 'ALL',
      frontendDestinations: 'ALL',
      agencyName: 'ALL',
      citationNumber: data.citationNumber,
    };
    const postParam = this.generateParams(prePrams);
    this.ecitationSearchService.getSearchResults(postParam).subscribe((res: any) => {
      this.selectedValue = res.content;
      this.showDetails = true;
    });
  }

  deleteSelected() {
    let filteredResults = this.selectedItems;
    if (filteredResults.length > 0) {
      let f2 = filteredResults.map((x: any) => { return x.citationNumber });
      this.ecitationSearchService.purgeRecords(filteredResults).subscribe((data) => {
        this.alertService.success(`Citation deleted sucessfully for ${f2.join(', ')}.`);
        this.selectedItems = [];
        this.onSearch(this.sortName, this.sortDir);
      });
    } else {
      this.alertService.error('Please select at least one citation to perform this action.');
    }
  }

  resendSelected() {
    let filteredResults = this.selectedItems;
    if (filteredResults.length > 0) {
      let f2 = filteredResults.map((x: any) => { return x.citationNumber });
      this.ecitationSearchService.resendCitation(filteredResults).subscribe((data) => {
        this.alertService.success(`Citation resent successfully for ${f2.join(", ")}.`);
        this.selectedItems = [];
      });
    } else {
      this.alertService.error('Please select at least one citation to perform this action');
    }
  }
}
